export enum ChartType {
  Bar = 'bar_chart',
  Line = 'line_chart',
}
